import React, { useEffect, useState } from 'react';

/**
 * E32 · the What's New picture slot (founder Q-wn-1 B, 2026-10-24) — ONE image above the summary,
 * from the variant's `mediaUrl`. Drawn only when present; a fixed max height with `object-fit:
 * contain`, so a tall or wide shot never pushes the text or the buttons off; a failed load removes
 * the slot (no broken-image icon). The alt text is the post's title — no string of its own.
 */
export const WhatsNewImage: React.FC<{
  mediaUrl?: string | null;
  alt: string;
  testId: string;
  maxHeight?: number;
}> = ({ mediaUrl, alt, testId, maxHeight = 180 }) => {
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [mediaUrl]);
  if (!mediaUrl || failed) return null;
  return (
    <img
      alt={alt}
      data-testid={testId}
      onError={() => setFailed(true)}
      src={mediaUrl}
      style={{
        display: 'block',
        maxHeight,
        maxWidth: '100%',
        objectFit: 'contain',
        margin: '0 0 8px',
      }}
    />
  );
};
